<template>
  <icon-base
    :height="height"
    :width="width"
    :styles="styles"
    view-box="0 0 44 44"
  >
    <circle
      class="path2"
      cx="22"
      cy="22"
      r="20"
      fill="none"
      stroke-width="4"
    />
    <circle
      class="path"
      cx="22"
      cy="22"
      r="20"
      fill="none"
      stroke-width="4"
    />
  </icon-base>
</template>

<script>
import IconBase from './IconBase'

export default {
  name: 'SpinnerIcon',
  components: {
    IconBase
  },
  props: {
    height: {
      type: [Number, String],
      default: () => null
    },
    width: {
      type: [Number, String],
      default: () => null
    },
    styles: {
      type: [Object, Array],
      default: () => []
    }
  }
}
</script>

<style lang="sass" scoped>
.path2
  stroke-dasharray: 150
  stroke-dashoffset: 0
  stroke: #E4E3E6
  stroke-linecap: round

.path
  stroke-dasharray: 1,150
  stroke-dashoffset: 0
  stroke: #345995
  stroke-linecap: round
  animation: dash 2s ease-in-out infinite

@keyframes dash
  0%
    stroke-dasharray: 1,150
    stroke-dashoffset: 0

  50%
    stroke-dasharray: 90,150
    stroke-dashoffset: -35

  100%
    stroke-dasharray: 90,150
    stroke-dashoffset: -124
</style>



// WEBPACK FOOTER //
// src/components/icons/SpinnerIcon.vue